import React, { useEffect } from 'react';
import * as styles from './AppFooter.module.scss';
import { Link, Text } from 'components/core';
import { Inline } from 'components/layout';
import { toggleHelplyFromReact } from 'util/helply';
import { applyHelplyButtonTriggerStyles } from 'util/helplyStyleTrigger';

const pageLinks = [
  { text: 'Your reviews', url: '/reviews/active' },
  { text: 'Profile', url: '/profile' },
  { text: 'Billing and plan', url: '/account' },
  { text: 'Email notifications', url: '/profile/privacy_and_permissions' },
  { text: 'Terms', url: 'https://www.covidence.org/terms' },
  { text: 'Privacy', url: 'https://www.covidence.org/privacy' },
  { text: 'Accessibility', url: 'https://www.covidence.org/accessibility/' },
];

const AppFooter = () => {
  const toggleHelplyWidget = async (e: any) => {
    e.preventDefault();

    try {
      await toggleHelplyFromReact();
    } catch (error) {
      console.log('Error toggling Helply widget: ', error);
    }
  };

  useEffect(() => {
    const cleanup = applyHelplyButtonTriggerStyles();
    return cleanup;
  }, []);

  return (
    <footer className={styles.AppFooter} id="footer" tabIndex={-1}>
      <Inline
        shouldWrap
        spacing={2}
        component="ul"
        className={styles.FooterList}
      >
        {pageLinks.map((link, index) => (
          <li key={index} className={styles.FooterItem}>
            <Link to={link.url} variant="brand">
              {link.text}
            </Link>
          </li>
        ))}
        <li className={styles.FooterItem}>
          <Link
            onClick={toggleHelplyWidget}
            variant="brand"
            // Special id that helply uses as a trigger
            id="contact-us-button"
            aria-label="Launch support chat widget"
          >
            Support
          </Link>
        </li>
      </Inline>
      <Text size="xs" variant="brand-strong">
        &copy; {new Date().getFullYear()} Covidence
      </Text>
    </footer>
  );
};

export default AppFooter;
